import './Loading.scss';

const Loading = () => {

    return (
        <div className="loading-container fixed-center">
            <div className="loading">
                <div className="loading-spinner"></div>
                {/* <p>Loading...</p> */}
            </div>
        </div>
    );
}

export default Loading;